export default __webpack_public_path__ + "static/media/BMWGroup-Regular.b82428b2.woff2";